import * as React from 'react';
import { SidebarHeader } from "../../sidebar/index.mjs";
import { GridChartsPanelDataSearch } from "./GridChartsPanelDataSearch.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
function GridChartsPanelDataHeader(props) {
  const {
    searchValue,
    onSearchValueChange
  } = props;
  return /*#__PURE__*/_jsx(SidebarHeader, {
    children: /*#__PURE__*/_jsx(GridChartsPanelDataSearch, {
      value: searchValue,
      onClear: () => onSearchValueChange(''),
      onChange: event => onSearchValueChange(event.target.value)
    })
  });
}
export { GridChartsPanelDataHeader };